export default __webpack_public_path__ + "static/media/workfields003.0b75f289.jpg";